import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useVerifyNIN = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    // const dispatch = useAppDisPatch();

    const onVerifyNINError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while verifying NIN.',
        );
    };

    const onVerifyNINSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        // toast.success(message || 'NIN verified successfully');
        callbackFn();
    };

    const verifyNIN = (data: { nin: string; firstName: string; lastName: string; }, callbackFn: () => void) => {

        // console.log(data);
        const url: HttpConfig = {
            url: 'ba/v1/drivers/verification/verify-identity',
            method: 'post',
            data
        };

        request(url, onVerifyNINSuccess(callbackFn), setLoading, onVerifyNINError);
    };

    return { verifyNIN, loading };
};

export default useVerifyNIN;
